import { createSlice } from '@reduxjs/toolkit';
import { api } from '../services/http';
import * as Sentry from '@sentry/react';

const initialState = {
  list: [],
  loadedUsers: false,
  isOpenModal: false,
};

const slice = createSlice({
  initialState,
  name: 'users',
  reducers: {
    startLoading(state) {
      state.loadedUsers = true;
    },
    hasError(state, action) {
      Sentry.captureException(action.payload);
      console.error(action.payload);
      state.loadedUsers = false;
    },
    getUsersSuccess(state, action) {
      state.list = action.payload.users;
      state.loadedUsers = false;
    },
    openModalUsersSuccess(state, action) {
      state.isOpenModal = action.payload;
    },
  },
});

// Reducer
export const usersReducer = slice.reducer;

// ----------------------------------------------------------------------

export const getUsers = (query) => async (dispatch) => {
  dispatch(slice.actions.startLoading());
  try {
    query = {
      all: true,
      withMe: true,
      ...query,
    };
    await api.get('/v1/users', query).then((res) => {
      api.get('/v1/users', { ...query, limit: res.pagination.totalCount }).then((response) => {
        dispatch(slice.actions.getUsersSuccess(response));
      });
    });
  } catch (err) {
    dispatch(slice.actions.hasError(err));
    Sentry.setExtra('Error Data', {
      status: err?.status,
      url: err?.url,
      body: err?.data,
    });
    Sentry.captureException(err);
  }
};

export const openModalUsers = (open) => async (dispatch) => {
  dispatch(slice.actions.openModalUsersSuccess(open));
};

// ----------------------------------------------------------------------
